<template>
  <div class="location" v-if="detail">
    <div class="notice">
      This is default meeting poing but you can set your own location by search
      as well
    </div>
    <google-map v-model="detail.location"></google-map>
    detail location: {{ detail.location }}
    <div class="description">
      <div class="about-the-location">
        <p>About the location</p>
        {{ detail.aboutTheLocation }}
        <br />
        <br />
        <!--<span class="place">{{serviceDetail.photographer.area.placeName}}</span>-->
        <!--<span class="add">- {{serviceDetail.photographer.area.address}}</span>-->
      </div>
      <div class="st">
        <span class="place">How to get here</span>
      </div>
      <div class="desc">{{ detail.howToGetHere }}</div>
    </div>
    <div class="sample-shots">
      <p class="title">Sample Shots</p>
      <div class="slide-box">
        <button class="prev" @click.stop="prev"></button>
        <button class="next" @click.stop="next"></button>
        <div
          class="image-box"
          v-for="(item, index) in previewImages"
          :class="{ 'active-image': item.show }"
          v-bind:key="index"
        >
          <img v-if="previewImages" v-imageLoading="item.src" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GoogleMap from '../common/GoogleMap'
import { getServiceArea } from '../../api/serviceArea'
import { getService } from '../../api/service'
import mixCommon from '../../mixin/common'

export default {
  mixins: [mixCommon],
  name: 'location',
  components: {
    GoogleMap
  },
  data() {
    return {
      previewImages: [],
      showImageNumbers: {
        one: 0,
        two: 1
      },
      detail: {},
      serviceDetail: null
    }
  },
  created() {
    getService(this.modalComponentPropData.serviceId).then(service => {
      console.log('service detail:', service)
      this.serviceDetail = service
      getServiceArea(this.serviceDetail.uid)
        .then(result => {
          console.log('location:', result)
          this.detail = result
          this.previewImages = []
          result.portfolio.forEach((value, index) => {
            console.log('Location value:', value)
            this.$set(this.previewImages, index, {
              show: false,
              src: value.thumbnailFullPath
            })
            // this.previewImages.push({
            //     show: false,
            //     src: value.url
            // })
          })
        })
        .then(() => {
          this.previewImages[0].show = true
          this.previewImages[1].show = true
        })
    })
  },
  methods: {
    next() {
      this.showImageNumbers.one += 2
      this.showImageNumbers.two += 2

      if (this.showImageNumbers.two >= this.previewImages.length) {
        this.showImageNumbers.one = this.previewImages.length - 2
        this.showImageNumbers.two = this.previewImages.length - 1
      }

      for (let i = 0; i < this.previewImages.length; i++) {
        if (
          this.showImageNumbers.one === i ||
          this.showImageNumbers.two === i
        ) {
          this.previewImages[i].show = true
        } else {
          this.previewImages[i].show = false
        }
      }
    },
    prev() {
      this.showImageNumbers.one -= 2
      this.showImageNumbers.two -= 2

      if (this.showImageNumbers.one <= 0) {
        this.showImageNumbers.one = 0
        this.showImageNumbers.two = 1
      }

      for (let i = 0; i < this.previewImages.length; i++) {
        if (
          this.showImageNumbers.one === i ||
          this.showImageNumbers.two === i
        ) {
          this.previewImages[i].show = true
        } else {
          this.previewImages[i].show = false
        }
      }
    }
  },
  computed: {
    ...mapGetters(['modalComponentPropData'])
  }
}
</script>

<style lang="scss" scoped>
.location {
  width: 95%;
  .notice {
    font-size: 16px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
  }
  .google-map {
    margin: 32px 0 0 0;
    width: 100%;
    height: 400px;
    /*border: 1px solid red;*/
  }

  .description {
    font-size: 16px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    margin: 18px 0 0 0;
    .address {
      margin: 20px 0 0 0;
      p {
        font-weight: 600;
        margin: 0 5px 20px 0;
        letter-spacing: normal;
      }

      .place {
        font-weight: 600;
        margin: 0 5px 0 0;
        letter-spacing: normal;
      }
    }

    .about-the-location p {
      font-weight: 600;
    }

    .desc {
      margin: 15px 0 0 0;
    }

    .st {
      font-weight: 600;
      margin: 15px 0 0 0;
    }
  }

  .sample-shots {
    width: 100%;
    /*border: 1px solid #DBDBDB;*/
    margin: 32px 0 0 0;
    padding: 20px 0;

    .title {
      font-size: 17px;
      font-weight: 600;
      letter-spacing: 1px;
      margin: 0 0 0 20px;
    }

    .slide-box {
      margin: 40px auto;
      position: relative;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      height: 400px;
      width: 647px;
      /*border: 1px dotted green;*/
      button {
        border: 0;
        outline: none;
        cursor: pointer;
        opacity: 0.4;
        background-color: #fff;
        position: absolute;
        z-index: 10;
        width: 55px;
        height: 55px;
      }
      .next {
        margin: auto 0;
        top: 0;
        bottom: 0;
        right: -70px;
        z-index: 10;

        &:before {
          border-right: 2px solid #0f00ff;
          border-bottom: 2px solid #0f00ff;
          content: '';
          margin: auto;
          top: 0;
          bottom: 0;
          right: 0;
          left: 8px;
          width: 15px;
          height: 15px;
          position: absolute;
          transform: rotate(-50deg);
          transition: all 0.3s ease-in-out;
        }

        &:after {
          border-top: 2px solid #0f00ff;
          content: '';
          margin: auto;
          top: 20px;
          bottom: 0;
          right: 0;
          left: -1px;
          width: 30px;
          height: 20px;
          position: absolute;
          transition: all 0.3s ease-in-out;
        }

        &:hover:before {
          left: 30px;
        }

        &:hover:after {
          left: 30px;
          width: 20px;
        }
      }
      .prev {
        margin: auto 0;
        top: 0;
        bottom: 0;
        left: -60px;
        &:before {
          border-top: 2px solid #0f00ff;
          border-left: 2px solid #0f00ff;
          content: '';
          margin: auto;
          top: 0;
          bottom: 0;
          right: 8px;
          left: 0;
          width: 15px;
          height: 15px;
          position: absolute;
          transform: rotate(-50deg);
          transition: all 0.3s ease-in-out;
        }

        &:after {
          border-top: 2px solid #0f00ff;
          content: '';
          margin: auto;
          top: 22px;
          bottom: 0;
          right: 0;
          left: -1px;
          width: 30px;
          height: 20px;
          position: absolute;
          transition: all 0.3s ease-in-out;
        }

        &:hover:before {
          left: -22px;
        }

        &:hover:after {
          left: -28px;
          width: 20px;
        }
      }
      .image-box {
        visibility: hidden;
        opacity: 0;
        margin: auto;
        /*border: 1px solid red;*/
        width: 300px;
        height: 401px;
        overflow: hidden;
        position: absolute;
        transition: all 0.3s ease-in-out;
        left: -100px;
        img {
          position: absolute;
          margin: auto;
          top: 0;
          bottom: 0;
          width: 100%;
          height: auto;
          flex-wrap: wrap-reverse;
        }

        &.active-image {
          left: 0;
          position: relative;
          visibility: visible;
          opacity: 1;
          transition: all 0.5s ease-in-out;
        }
      }
    }
  }
}
</style>
